module.exports = __webpack_public_path__ + "img/nanjing_park.34b58c32.png";